<template>
    <v-card>
        <v-data-table
            :footer-props="{itemsPerPageOptions:[1,5,10]}"
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="total"
            :loading="loading"
            class="elevation-0 dataTable pt-3"
        >
            <template
                v-slot:body.prepend="{ headers }"
            >
                <tr>
                    <td>
                        <v-text-field
                            v-model="userName"
                            label="Buscar usuário..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()">
                        </v-text-field>
                    </td>
                    <td>
                        <v-text-field
                            v-model="userEmail"
                            label="Buscar email..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()">
                        </v-text-field>
                    </td>
                    <td>
                        <v-menu
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    class="mt-5"
                                    v-model="showDate"
                                    label="Data"
                                    persistent-hint
                                    prepend-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dateCalendar"
                                range
                                no-title
                            ></v-date-picker>
                        </v-menu>
                    </td>
                    <td class="td-actions text-center" >
                        <v-btn
                            class="mt-4"
                            depressed
                            width="80%"
                            color="primary"
                            v-on:click="getData()"
                        >
                            Buscar
                        </v-btn>
                        <v-btn
                            class="mb-4 mt-4"
                            depressed
                            width="80%"
                            color="#FBC02D"
                            v-on:click="getCleanFilter()"
                        >
                            Limpar
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:item.created_at="{ item }">
                {{ parseDate(item.created_at, 'DD/MM/YYYY H:mm') }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-container class="pa-0 ma-0 text-center">
                    <template v-if="isUserActive(item)">
                        <v-tooltip bottom v-if="canEditUsers">
                            <template #activator="{ on }">
                                <v-icon
                                    v-on="on"
                                    small
                                    class="mr-2 edit"
                                    @click="$emit('edit-user', item)"
                                >
                                    mdi-pencil
                                </v-icon>
                            </template>
                            Editar Usuário
                        </v-tooltip>
                        <v-tooltip bottom v-if="canDeleteUsers">
                            <template #activator="{ on }">
                                <v-icon
                                    class="delete"
                                    v-on="on"
                                    small
                                    @click="openModal(item)"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>
                            Excluir Usuário
                        </v-tooltip>
                    </template>
                    <template v-else>
                        <v-tooltip bottom v-if="canEditUsers">
                            <template #activator="{ on }">
                                <v-icon
                                    v-on="on"
                                    small
                                    class="mr-2 edit"
                                    @click="openReactivateUserModal(item)"
                                >
                                    mdi-arrow-up-thick
                                </v-icon>
                            </template>
                            Reativar Usuário
                        </v-tooltip>
                    </template>
                </v-container>
            </template>
        </v-data-table>
        <confirm-deletion-modal
            :dialog-active="deleteUserDialog"
            :dialog-loading="deleteUserDialogLoading"
            :entity-to-delete="user.name"
            @close-dialog="deleteUserDialog = false"
            @delete-method="deleteUser(user.id)"
        />
        <confirm-action-dialog
            title="Reativar Usuário"
            type="warning"
            action-button-label="Reativar"
            :model.sync="reactiveUserModal.model"
            :message="reactiveUserModal.message"
            @confirm="reactivateUser()"
        />
        <response-dialog
            :model.sync="reactiveUserModal.responseModel"
            :type="reactiveUserModal.responseType"
            :message="reactiveUserModal.responseMessage"
            @close="reloadPage()"
        />
    </v-card>
</template>

<script>
import moment from "moment";
import ConfirmDeletionModal from "../Modals/ConfirmDeletionModal";
import ConfirmActionDialog from "../Dialog/ConfirmActionDialog.vue";
import ResponseDialog from "../Dialog/ResponseDialog.vue";

export default {
    name: "ListUser",

    components: {
        ResponseDialog,
        ConfirmActionDialog,
        ConfirmDeletionModal,
    },

    data: () => ({
        headers: [
            {text: 'Nome', value: 'name'},
            {text: 'Email', value: 'email', sortable: false},
            {text: 'Criado em', value: 'created_at'},
            {text: 'Ações', value: 'actions', sortable: false},
        ],
        items: [],
        loading: true,
        total: 0,
        options: {
            sortDesc: [true],
        },
        userName: '',
        userEmail: '',
        showDate: '',
        created_at: '',
        dateCalendar: [],
        deleteUserDialog: '',
        deleteUserDialogLoading: '',
        user: {},
        reactiveUserModal: {
            model: false,
            message: '',
            responseModel: false,
            responseType: '',
            responseMessage: ''
        }
    }),

    props: {
        listInactiveUsers: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        canEditUsers () {
            return this.$can('edit.users');
        },
        canDeleteUsers () {
            return this.$can('delete.users');
        }
    },

    mounted() {
        if(Object.keys(this.$route.query).length) {
            const {sort, sortDesc, page, perPage, userName, userEmail, created_at, until, thisMonth} = this.$route.query;
            if(sort) {
                this.options.sortBy = sort;
            }
            if(sortDesc) {
                this.options.sortDesc = sortDesc;
            }
            if(page) {
                this.options.page = parseInt(page ? page : 1);
            }
            if(perPage) {
                this.options.perPage = perPage;
            }
            if(userName) {
                this.userName = userName;
            }
            if(userEmail) {
                this.userEmail = userEmail;
            }
            if(created_at) {
                this.created_at = created_at;
            }
            if(until) {
                this.until = until;
            }
            if(thisMonth) {
                this.thisMonth = thisMonth;
            }
        }
    },

    methods: {
        parseDate(date, format) {
            return moment(date).format(format);
        },
        formatDate (dateCalendar) {
            if (!dateCalendar) return null

            const [year, month, day] = dateCalendar.split('-')
            return `${day}/${month}/${year}`
        },
        getData() {
            this.loading = true;
            const {sortBy, sortDesc, page, itemsPerPage} = this.options;
            const queryParams = {
                sort: sortBy,
                sortDesc: sortDesc,
                page: page,
                perPage: itemsPerPage,
                userName: this.userName,
                userEmail: this.userEmail,
                created_at: this.created_at,
                until: this.until,
                thisMonth: this.thisMonth,
                listInactive: this.listInactiveUsers
            };

            this.$router.push({ query: queryParams });

            axios.get(`/api/user/list`, { params: queryParams })
                .then(res => {
                    this.items = res.data.data;
                    this.total = res.data.total;
                    this.loading = false;
                });
        },
        getCleanFilter() {
            this.$router.replace({'query': null});
            window.location.reload();
        },
        openModal(item) {
            this.deleteUserDialog = true;
            this.user = item;
        },
        closeModal() {
            this.deleteUserDialogLoading = false;
            this.deleteUserDialog = false;
        },
        deleteUser(id) {
            this.deleteUserDialogLoading = true;
            axios.delete(`api/user/${id}`)
                .then(() => {
                    this.deleteUserDialog = false;
                    window.location.reload();
                    this.$forceUpdate();
                })
        },
        isUserActive (user) {
            return user.deleted_at === undefined || user.deleted_at === null;
        },
        openReactivateUserModal (selectedUser) {
            this.user = selectedUser;
            this.reactiveUserModal.message = `Deseja realmente reativar o(a) usuário(a) ${selectedUser.name} ?`;
            this.reactiveUserModal.model = true;
        },
        reactivateUser () {
            axios.post(`api/user/${this.user.id}/reactivate`, {}, { validateStatus: () => true }).then((response) => {
                response.data.success ? this.onReactivateUserSuccess() : this.onReactivateUserError(response);
            }).catch((error) => {});
        },
        onReactivateUserSuccess () {
            this.reactiveUserModal.responseMessage = "O usuário foi reativado com sucesso!"
            this.reactiveUserModal.responseType = 'success';
            this.reactiveUserModal.model = false;
            this.reactiveUserModal.responseModel = true;
        },
        onReactivateUserError (response) {
            this.reactiveUserModal.responseMessage = "Ocorreu um erro inesperado. Tente novamente."
            this.reactiveUserModal.responseType = 'error';
            this.reactiveUserModal.model = false;
            this.reactiveUserModal.responseModel = true;
        },
        reloadPage () {
            window.location.reload();
            this.$forceUpdate();
        }
    },

    watch: {
        options: {
            handler() {
                this.getData()
            },
            deep: true,
        },
        dateCalendar (val) {
            let created_at= this.formatDate(this.dateCalendar[0])
            if (this.dateCalendar[1] != null ){
                let until= this.formatDate(this.dateCalendar[1])
                this.showDate= created_at + " ate " + until
                this.created_at = this.dateCalendar[0]
                this.until = this.dateCalendar[1]
            }

        },
        listInactiveUsers (val) {
            this.getData();
        }
    }

}
</script>

<style scoped>
    .v-dialog .v-card__text {
        padding: 0 !important;
    }
    .v-dialog .v-alert {
        border-radius: 0 !important;
    }
    .v-dialog, .v-dialog .v-card__text {
        overflow: hidden !important;
    }
    .delete:hover {
        color: #f44336;
    }
    .dataTable {
        border-bottom: 1px solid rgba(0, 0, 0, .12);
        border-radius: 0;
    }
    .dataTable .v-data-table-header tr th span {
        font-size: 14px !important;
    }
    .edit:hover {
        color: #009efb;
    }
    a {
        text-decoration: none;
    }
    .td-actions{
        width:17%
    }
</style>
